import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EntidadeSeguroService {
  private readonly path = 'EntidadeSeguro';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // GET /EntidadeSeguro
  list(params?: any): Observable<any> {
    return this.apiService.get<any>(
      `${this.path}`,
      params
        ? new HttpParams({ fromObject: params })
        : this.params
    );
  }

  // GET /EntidadeSeguro/{Id}
  show(id: string | number): Observable<any> {
    return this.apiService.get<any>(`${this.path}/${id}`);
  }

  // POST /EntidadeSeguro
  store(formData: any): Observable<any> {
    return this.apiService.post<any>(`${this.path}`, formData);
  }

  // PUT /EntidadeSeguro
  update(formData: any): Observable<any> {
    return this.apiService.put<any>(`${this.path}`, formData);
  }

  // DELETE /EntidadeSeguro/{Id}
  delete(id: string | number): Observable<any> {
    return this.apiService.delete<any>(`${this.path}/${id}`);
  }

  // PATCH /EntidadeSeguro/{Id}
  patch(id: string | number, data: any): Observable<any> {
    return this.apiService.patch<any>(`${this.path}/${id}`, data);
  }

  // POST /EntidadeSeguro/range
  postRange(data: any): Observable<any> {
    return this.apiService.post<any>(`${this.path}/range`, data);
  }
}
